import useBasicColumnConfig from "../../main/config/column/default/BasicColumnConfig";
import useBooleanColumnConfig from "../../main/config/column/default/BooleanColumnConfig";
import useCompanyColumnConfig from "../../main/config/column/default/CompanyColumnConfig";
import DataTableConfig from "../../main/config/dataTable/DataTableConfig";
import DataTable, { useDataTable } from "../../main/DataTable";

function EmployeeLogsDataTable() {
  //Create the datatable config
  const config = new DataTableConfig("employee_logs");

  //Set the datatable fetch info
  config.setFetchRequest("employee_logs");
  config.setFetchParams({
    with_employee_log_employee_data: true,
    with_employee_log_location_data: true,
    with_employee_log_company_data: true,
  });

  //Set the datatable order by
  config.setOrderBy("signed_in_at");
  config.setOrderDirection("desc");

  //set the datatable columns
  config.setColumns([
    useCompanyColumnConfig(),
    useBasicColumnConfig("location.name").setData(
      (row) => row.location?.name ?? row.location_name
    ),
    useBasicColumnConfig("employee.name").setData(
      (row) => row.employee?.name ?? row.employee_name
    ),
    useBasicColumnConfig("signed_in_at").setUseFromToDateTime(true),
    useBasicColumnConfig("signed_out_at"),
    useBooleanColumnConfig("auto_signed_out").setActive(false),
  ]);

  //Set show saved filters
  config.setShowSavedFilters(true);
  
  //Create the datatable object
  const dataTable = useDataTable(config);

  return <DataTable controller={dataTable} />;
}

export default EmployeeLogsDataTable;
